import {
  message,
  PageHeader,
  Spin,
  Select,
  Row,
  Col,
  Input,
  Modal,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  cuentaMask,
  dineroDisabledMask,
  round2Decimals,
  InputItem,
  ButtonItem,
  ErrorItem
} from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import AgregarTipoDePoliza from "../../TiposDePolizas/AgregarTipoDePoliza/AgregarTipoDePoliza";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";

const { Option } = Select;

class EditarPlantillaPoliza extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: null,
    todasInsumos: null,
    todasTiposDePolizas: null,
    objetoTiposDePolizas: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    modalAgregarTipoDePoliza: false,
    impuestos: [],
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasCuentaContable: res.data,
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "tiposdepolizas/selectTiposDePolizas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasTiposDePolizas: res.data,
            objetoTiposDePolizas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "plantillasPolizas/datosPlantilla",
        { empresaId: this.props.empresaId, plantillaId: this.props.location.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.formRef.current.setFieldsValue({
            ...res.data.plantilla,
          });
        } else {
          message.error("Error no se encontro informacion de la plantilla");
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    let total = 0
    values.cargosAbonos.map(value => {
      if (!value) return null
      if (value.cargo) {
        total = round2Decimals(total + value.cargo)
      }
      if (value.abono) {
        total = round2Decimals(total - value.abono)
      }
      return null
    })
    if (Math.abs(round2Decimals(total)) !== 0) return message.info('Los cargos y abonos deben coincidir')
    this.setState({ loading: true });
    axios
      .post(
        "plantillasPolizas/editarPlantilla",
        {
          ...values,
          empresaId: this.props.empresaId,
          plantillaId: this.props.location.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha editado una plantilla de poliza"
          );
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error("No se pudo editar la plantilla de poliza");
        } else {
          message.error("Hubo un error y la plantilla de poliza no se edito");
        }
      });
  }
  abrirAgregarTipoDePoliza() {
    this.setState({ modalAgregarTipoDePoliza: true });
  }
  cerrarAgregarTipoDePoliza(codigo) {
    this.setState({ modalAgregarTipoDePoliza: false });
    this.consultarTodo();
  }
  // El concepto del encabezado casi siempre se repite en cada movimiento, asi que este boton
  // lo copia de un jalon en vez de teclearlo renglon por renglon.
  copiarConceptoATodos() {
    const concepto = this.formRef.current.getFieldValue("concepto");
    if (!concepto) return message.info("Primero captura el concepto de la plantilla");

    const cargosAbonos = this.formRef.current.getFieldValue("cargosAbonos") || [];
    if (cargosAbonos.length === 0) return message.info("No hay cargos y abonos");

    // Renglones nuevos, nunca el mismo array: setFieldsValue con la misma referencia no
    // notifica a los shouldUpdate de la tabla y la columna se queda en blanco. Los renglones
    // recien agregados valen undefined hasta que se teclea algo, de ahi el objeto nuevo.
    const copiar = () => {
      this.formRef.current.setFieldsValue({
        cargosAbonos: cargosAbonos.map((valueCA) =>
          valueCA ? { ...valueCA, concepto } : { concepto }
        ),
      });
      message.success("Concepto copiado a " + cargosAbonos.length + " movimientos");
    };

    // Solo se pregunta cuando hay conceptos distintos capturados a mano, que es lo unico
    // que se perderia.
    const pisaCapturados = cargosAbonos.some(
      (valueCA) => valueCA?.concepto && valueCA.concepto !== concepto
    );
    if (pisaCapturados) {
      return Modal.confirm({
        title: "Copiar el concepto a todos los movimientos",
        content: "Hay renglones con un concepto distinto y se va a reemplazar.",
        okText: "Continuar",
        cancelText: "Cancelar",
        onOk: copiar,
      });
    }

    copiar();
  }
  getCargosAbonosColumns() {
    return [
      { title: "Cuenta Contable", width: "25%" },
      { title: "Cargo", width: "22%" },
      { title: "Abono", width: "22%" },
      { title: "Concepto", width: "22%" },
      { title: "Acciones", width: "9%" },
    ];
  }
  renderCargoAbonoRow({ key, name, fieldKey: _fieldKey, restField, arrayKey, remove }) {
    return (
      <tr key={key}>
        <td className="td-border">
          <FormItem
            {...restField}
            name={[name, "cuentaContableId"]}
            fieldKey={[arrayKey, "cuentaContableId"]}
            required
            noStyle
          >
            <SelectItem sinBorde autoFocus width="100%" placeholder="Cuenta">
              {this.state.objetoCuentaContable}
            </SelectItem>
          </FormItem>
        </td>
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const arrayCargosAbonos = getFieldValue('cargosAbonos')
              const disabled = arrayCargosAbonos[arrayKey] ? arrayCargosAbonos[arrayKey].abono : false
              return (
                <FormItem
                  {...restField}
                  name={[name, "cargo"]}
                  fieldKey={[arrayKey, "cargo"]}
                  required={!disabled}
                  number
                  noStyle
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled={disabled} dinero />
                </FormItem>
              )
            }}
          </FormItem>
        </td>
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const arrayCargosAbonos = getFieldValue('cargosAbonos')
              const disabled = arrayCargosAbonos[arrayKey] ? arrayCargosAbonos[arrayKey].cargo : false
              return (
                <FormItem
                  {...restField}
                  name={[name, "abono"]}
                  fieldKey={[arrayKey, "abono"]}
                  required={!disabled}
                  number
                  noStyle
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled={disabled} dinero />
                </FormItem>
              )
            }}
          </FormItem>
        </td>
        <td className="td-border">
          <FormItem
            {...restField}
            name={[name, "concepto"]}
            fieldKey={[arrayKey, "concepto"]}
            required
            noStyle
          >
            <InputItem placeholder="Concepto" sinBorde />
          </FormItem>
        </td>
        <td className="td-border-sin-right">
          <Row className="acciones-container">
            <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
              <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                <ButtonItem
                  rojo2
                  icon={<DeleteOutlined />}
                  onClick={() => remove(name)}
                  size="small"
                />
              </Tooltip>
            </Col>
          </Row>
        </td>
      </tr>
    );
  }
  getObservacionesConfig() {
    return {
      totales: (
        <FormItem noStyle shouldUpdate>
          {({ getFieldValue }) => {
            let cargosAbonos = getFieldValue('cargosAbonos') || []
            let totalCargos = 0
            let totalAbonos = 0
            let total = 0
            cargosAbonos.map(value => {
              if (!value) return null
              if (value.cargo) {
                totalCargos = round2Decimals(totalCargos + value.cargo)
                total = round2Decimals(total + value.cargo)
              }
              if (value.abono) {
                totalAbonos = round2Decimals(totalAbonos + value.abono)
                total = round2Decimals(total - value.abono)
              }
              return null
            })
            return (
              <table className="table" style={{ borderCollapse: "collapse", width: "100%", margin: 0, tableLayout: "auto" }}>
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ width: "50%" }}>Total Cargos:</th>
                    <td className="td-totales-right">{dineroDisabledMask(totalCargos)}</td>
                  </tr>
                  <tr>
                    <th className="th-totales" style={{ width: "50%" }}>Total Abonos:</th>
                    <td className="td-totales-right">{dineroDisabledMask(totalAbonos)}</td>
                  </tr>
                  <tr>
                    <th className="th-totales" style={{ width: "50%" }}>Saldo:</th>
                    <td className="td-totales-right">{dineroDisabledMask(Math.abs(total))}</td>
                  </tr>
                </tbody>
              </table>
            )
          }}
        </FormItem>
      ),
    };
  }
  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Editar Plantilla de Poliza"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="editarPlantillaPoliza"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <GeneralFormLayout
                cards={[
                  {
                    title: "Datos Generales",
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col span={12}>
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem placeholder="Proyecto">
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                            label="Tipo de Poliza"
                            margin
                          >
                            <Input.Group compact>
                              <FormItem name="tipoDePolizaId" required noStyle>
                                <SelectItem
                                  placeholder="Tipo de Poliza"
                                  width="80%"
                                >
                                  {this.state.objetoTiposDePolizas}
                                </SelectItem>
                              </FormItem>
                              <ButtonItem
                                blanco
                                icon={<PlusOutlined />}
                                style={{ width: "20%" }}
                                onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                              />
                            </Input.Group>
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem label="Concepto" margin>
                            <Input.Group compact>
                              <FormItem
                                name="concepto"
                                pattern
                                required
                                noStyle
                              >
                                <InputItem placeholder="Concepto" width="80%" />
                              </FormItem>
                              <Tooltip title="Copiar el concepto a todos los movimientos">
                                <ButtonItem
                                  blanco
                                  icon={<CopyOutlined />}
                                  style={{ width: "20%" }}
                                  onClick={this.copiarConceptoATodos.bind(this)}
                                />
                              </Tooltip>
                            </Input.Group>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "cargosAbonos",
                      label: "Cargos y Abonos",
                      listName: "cargosAbonos",
                      minWidth: "700px",
                      columns: this.getCargosAbonosColumns(),
                      renderRow: (rowProps) => this.renderCargoAbonoRow(rowProps),
                      renderFooter: ({ add }) => (
                        <FormItem noStyle>
                          <ButtonItem
                            type="primary"
                            cyan
                            block
                            hotkey="alt+a"
                            style={{ marginTop: 10 }}
                            icon={<PlusOutlined />}
                            onClick={() => add()}
                          >
                            Agregar Campo
                          </ButtonItem>
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                totalesMaxWidth="35%"
                actionButtons={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    hotkey="shift+e"
                    style={{ width: "5%" }}
                  >
                    Editar
                  </ButtonItem>
                }
              />
            </Form>
          </Spin>
        </div>
        <AgregarTipoDePoliza
          visible={this.state.modalAgregarTipoDePoliza}
          cerrarAgregarTipoDePoliza={this.cerrarAgregarTipoDePoliza.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarPlantillaPoliza);
